import useBackendUser from '@/hooks/useBackendUser';
import HeaderMenuDropdown from '../HeaderMenuDropdown/HeaderMenuDropdown';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton from 'react-loading-skeleton';
import HeaderUserDropdown from './HeaderUserDropdown';
import HeaderNotificationsDropdown from '../HeaderNotificationDropdown/HeaderNotificationsDropdown';
import uiItems from '@/constants/ui-items/index.constants';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import HeaderWishlistDropdown from '../HeaderMenuDropdown/HeaderWishlistDropdown';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { useRouter } from 'next/router';
import { PrimaryButton } from '@/components/common/PrimaryButton';
import { Routes } from '@/types/routes.enum';
import LanguageSwitcher from '@/components/languageSwitcher';
import useEvents from '@/hooks/useEvents';
import { useAnalytics } from '@/hooks/useAnalytics';
export default function HeaderUserActions() {
  const { data: user, isLoading: isUserLoading } = useBackendUser();
  const { translate: translateHeader } = useTypedTranslation<HeaderEnum>('header');
  const router = useRouter();
  const { getPageType } = useAnalytics();
  const {
    fireGlobalBrandButtonClickEvent,
    fireGlobalCountryButtonClickEvent,
    fireSignInButtonClickEvent,
    fireSignUpButtonClickEvent,
  } = useEvents('', []);
  const handleBecomeASellerClick = () => {
    router.push('/dashboard/settings/seller-profile/become-a-seller');
  };
  function handleSignInClick() {
    fireSignInButtonClickEvent({
      page_type: getPageType(),
    });
    router.push(Routes._AUTH_SIGN_IN);
  }
  function handleSignUpClick() {
    fireSignUpButtonClickEvent({
      page_type: getPageType(),
    });
    router.push(Routes._AUTH_SIGN_UP);
  }

  if (isUserLoading) {
    return (
      <div className="tw-flex tw-items-stretch tw-gap-6">
        <div className="tw-flex tw-items-center tw-gap-8">
          <Skeleton height={40} width={100} />
          <Skeleton height={40} width={100} />
          <Skeleton height={40} width={100} />
        </div>
        <div className="tw-flex tw-items-center tw-gap-4">
          <Skeleton circle height={40} width={40} />
          <Skeleton circle height={40} width={40} />
          <Skeleton height={40} width={120} />
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="tw-flex tw-items-stretch tw-gap-6">
        <div className="tw-flex tw-items-center tw-gap-6">
          <div>
            <HeaderMenuDropdown
              label={translateHeader(HeaderEnum['browse_menu.browse'])}
              items={uiItems.headerV2.browseMenu(
                getPageType,
                fireGlobalBrandButtonClickEvent as any,
                fireGlobalCountryButtonClickEvent as any,
                router.push
              )}
            />
          </div>
          <div>
            <HeaderMenuDropdown
              label={translateHeader(HeaderEnum['about'])}
              items={uiItems.headerV2.aboutMenu}
            />
          </div>
          <div>
            <HeaderMenuDropdown
              label={translateHeader(HeaderEnum['sell_menu.sell_menu'])}
              items={uiItems.headerV2.sellMenu(handleBecomeASellerClick)}
            />
          </div>
        </div>
        <div className="tw-flex tw-items-center tw-gap-2">
          <div className="tw-flex tw-items-center tw-gap-4">
            <PrimaryButton onClick={handleSignInClick}>
              {translateHeader(HeaderEnum['sign_in'])}
            </PrimaryButton>
            <PrimaryButton outlined={true} onClick={handleSignUpClick}>
              {translateHeader(HeaderEnum['sign_up'])}
            </PrimaryButton>
          </div>
          <div className="child:tw-m-0">
            <LanguageSwitcher isHeader={true} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tw-flex tw-items-stretch tw-gap-6">
      <div className="tw-flex tw-items-center tw-gap-8">
        <div>
          <HeaderMenuDropdown
            label={translateHeader(HeaderEnum['browse_menu.browse'])}
            items={uiItems.headerV2.browseMenu(
              getPageType,
              fireGlobalBrandButtonClickEvent as any,
              fireGlobalCountryButtonClickEvent as any,
              router.push
            )}
          />
        </div>
        <div>
          <HeaderMenuDropdown
            label={translateHeader(HeaderEnum['about'])}
            items={uiItems.headerV2.aboutMenu}
          />
        </div>
        <div>
          <HeaderMenuDropdown
            label={translateHeader(HeaderEnum['sell_menu.sell_menu'])}
            items={uiItems.headerV2.sellMenu(handleBecomeASellerClick)}
          />
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-gap-4">
        <div>
          <HeaderWishlistDropdown />
        </div>
        <div>
          <HeaderNotificationsDropdown />
        </div>
        <div>
          <HeaderUserDropdown />
        </div>
      </div>
    </div>
  );
}
